import React, { useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
// Api and Hook Imports
import { useApi } from '../../../hooks/UseApi';
import RoleApi from '../../../api/RoleApi';
// Design System Imports and Components
import { Input, Button } from '../../../designSystem/DesignSystem';
import { Modal } from '../../../components/modal';
import Markdown from '../../../components/markdown/Markdown';
//Helper Imports
import { isValidValue, editModalMapping } from '../../../helpers/Helper';
import { INFO_MESSAGES, showErrorMes, showSuccessMes } from '../../../helpers/NotificationHelper';
import { titleTranslation } from '../../../helpers/TranslationHelper';

const RoleModal = (props) => {
  const { isOpen, data, closeModal, projectId } = props;
  const { t } = useTranslation();
  const { control, handleSubmit, setValue, reset } = useForm({
    mode: 'onBlur',
    shouldFocusError: true,
    criteriaMode: 'all'
  });

  const createEditRole = useApi({
    name: 'saving role',
    api: isValidValue(data) ? RoleApi.edit : RoleApi.create,
    onSuccess: () => {
      showSuccessMes(INFO_MESSAGES.save);
      closeModal(createEditRole?.data);
    },
    onError: (err) => showErrorMes(err)
  });

  const onSubmit = (form) => {
    const body = {
      ...(isValidValue(data) && { id: data.id }),
      name: form.name,
      description: isValidValue(form.description) ? form.description : '',
      projectId: projectId
    };
    createEditRole.execute(body);
  };

  useEffect(() => {
    if (isValidValue(data)) {
      let mappedArray = editModalMapping(data);
      mappedArray.forEach(({ name, value }) => setValue(name, value));
    }
  }, []);

  return (
    <>
      <Modal
        open={isOpen}
        close={() => closeModal}
        w={'md'}
      >
        <Modal.Title>{titleTranslation(t('Role'), data, '', t)}</Modal.Title>

        <form
          className="flex flex-grow flex-col gap-4"
          onSubmit={handleSubmit(onSubmit)}
        >
          <Modal.Content h={'md'}>
            <div className="flex flex-grow flex-col gap-5">
              <Input
                required
                name="name"
                label={t('Name')}
                placeholder={t(`Enter a Role Name`)}
                control={control}
              />
              <Markdown
                control={control}
                name="description"
                label={t('Description')}
              />
            </div>
          </Modal.Content>
          <Modal.Buttons>
            <Button
              id="roleModal-cancel-button"
              secondary
              text={t('Cancel')}
              onClick={() => {
                closeModal();
                reset();
              }}
            />
            <Button
              id="roleModal-submit-button"
              primary
              text={t('Submit')}
              type="submit"
              loading={createEditRole?.loading}
            />
          </Modal.Buttons>
        </form>
      </Modal>
    </>
  );
};
export default RoleModal;
